import type { HullFamily } from "./hull-models.js";

export interface HullBase {
  id: HullFamily;
  name: string;
  role: string;
  limitation: string;
  price: string;
  capacity: number;
  hp: number;
  shield: number;
  speed: number;
  turnRate: number;
  radius: number;
  frontalDamageFactor: number;
  boostEnergyFactor: number;
  repairFactor: number;
  weaponDamageFactor: number;
  discoveryRange: number;
  barrierEnergyCost: number;
}
export const HULL_BASES: Record<HullFamily, HullBase> = {
  assault: {
    id: "assault",
    name: "Штурмовик",
    role: "Прямой бой: урон спереди ниже на 15%",
    limitation: "Средняя скорость и трюм",
    price: "0",
    capacity: 32,
    hp: 120,
    shield: 80,
    speed: 230,
    turnRate: 3.5,
    radius: 22,
    frontalDamageFactor: 0.85,
    boostEnergyFactor: 1,
    repairFactor: 1,
    weaponDamageFactor: 1,
    discoveryRange: 160,
    barrierEnergyCost: 35,
  },
  interceptor: {
    id: "interceptor",
    name: "Перехватчик",
    role: "Погоня и отход: форсаж тратит на 20% меньше",
    limitation: "Мало защиты и небольшой трюм",
    price: "420",
    capacity: 24,
    hp: 90,
    shield: 45,
    speed: 285,
    turnRate: 4.6,
    radius: 18,
    frontalDamageFactor: 1,
    boostEnergyFactor: 0.8,
    repairFactor: 1,
    weaponDamageFactor: 1,
    discoveryRange: 160,
    barrierEnergyCost: 35,
  },
  engineer: {
    id: "engineer",
    name: "Инженер",
    role: "Ремонт корпуса эффективнее на 25%",
    limitation: "Собственный урон ниже на 15%",
    price: "720",
    capacity: 32,
    hp: 110,
    shield: 75,
    speed: 220,
    turnRate: 3.2,
    radius: 24,
    frontalDamageFactor: 1,
    boostEnergyFactor: 1,
    repairFactor: 1.25,
    weaponDamageFactor: 0.85,
    discoveryRange: 160,
    barrierEnergyCost: 35,
  },
  scout: {
    id: "scout",
    name: "Разведчик",
    role: "Обнаруживает скрытые контейнеры на 650 единицах",
    limitation: "Слабая защита и небольшой трюм",
    price: "600",
    capacity: 24,
    hp: 85,
    shield: 50,
    speed: 270,
    turnRate: 4.2,
    radius: 18,
    frontalDamageFactor: 1,
    boostEnergyFactor: 1,
    repairFactor: 1,
    weaponDamageFactor: 1,
    discoveryRange: 650,
    barrierEnergyCost: 35,
  },
  transport: {
    id: "transport",
    name: "Транспорт",
    role: "Вместительный трюм; барьер стоит 25 энергии",
    limitation: "Низкая скорость и медленный разворот",
    price: "900",
    capacity: 64,
    hp: 160,
    shield: 95,
    speed: 180,
    turnRate: 2.3,
    radius: 30,
    frontalDamageFactor: 1,
    boostEnergyFactor: 1,
    repairFactor: 1,
    weaponDamageFactor: 1,
    discoveryRange: 160,
    barrierEnergyCost: 25,
  },
};
